export default __webpack_public_path__ + "static/media/resume.35f48315.pdf";